import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import toaster from 'utils/toaster';

export interface IChangeProfileImage {
  employee_image: any;
}

const changeProfileImage = (postData: IChangeProfileImage) => {
  const postFormData: any = new FormData();
  for (const key in postData) {
    // @ts-ignore
    const value: any = postData[key];
    postFormData.append(`${key}`, value);
  }

  return http('multipart').post(endpoints.profile.changeProfileImage, postFormData);
};

export function useChangeProfileImage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changeProfileImage,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });

      if (data.message) {
        toaster.success({ description: data.message });
      }
    },
  });
}
